const request = require("superagent");
const { Bearer } = require("superagent-authorization");
const contentURL = "https://content-api-p42fx5vvrq-uc.a.run.app/v1/contents";

class CertificateService {
  constructor(auth) {
    this.auth = auth;
    this.data = null;
  }

  get(force = false) {
    if (!force && this.data) {
      return Promise.resolve(this.data);
    }
    return new Promise((resolve, reject) => {
      request
        .get(contentURL)
        .query({ type: "certificate" })
        .use(Bearer(this.auth.token))
        .end((err, response) => {
          if (err) {
            reject(err);
          } else {
            this.data = {};
            response.body.forEach(item => {
              this.data[item.id] = item.data;
            });
            resolve(this.data);
          }
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      request
        .del(`${contentURL}/${id}`)
        .use(Bearer(this.auth.token))
        .end(err => {
          if (err) {
            reject(err);
          } else {
            delete this.data[id];
            resolve();
          }
        });
    });
  }

  saveOrUpdate(id, certificate, update = false) {
    return new Promise((resolve, reject) => {
      const action = update
        ? request.put(`${contentURL}/${id}`)
        : request.post(contentURL);
      action
        .use(Bearer(this.auth.token))
        .send({ id, type: "certificate", data: certificate })
        .end(err => {
          if (err) {
            reject(err);
          } else {
            this.data[id] = certificate;
            resolve();
          }
        });
    });
  }
}

class API {
  constructor(firebase) {
    this.certificates = new CertificateService(firebase);
  }
}

export default {
  install(Vue) {
    Vue.prototype.$api = new API(Vue.prototype.$auth);
  }
};
